export const setPermissionsRedux = (payload) => {
  return {
    type: "SET_PERMISSIONS",
    payload,
  };
};
